// extracted by mini-css-extract-plugin
module.exports =  {"filename":"UZAYLDtOybs_9YQHmTgu"};